<template>

  <div class="content-i">
    <div class="content-box">
      <div class=" single-page-container">
        <div class="col-sm-6 col-md-3 pl-0 pr-0 middle middle">
          <SessionInfoBlock :mainUser="sessionInfoBlock.mainUser" :session="sessionInfoBlock.session" :totalProducts="products.length" :type="'photodesk'" />
        </div>
        <div class="col-sm-6 middle">
          <div class="support-index">
            <div class="support-tickets">

              <div class="support-tickets-header pt-2" v-if="session.status == 4">
                  <div class="tickets-control alert alert-warning">
                        We are importing valid products in this session <br />
                        This page will refresh when import is complete

                  </div>
              </div>
              <div class="support-tickets-header pt-2" v-if="session.status == 5">
                  <div class="tickets-control alert alert-warning">

                        We are still processing the images for this session. Status will auto refresh every minute
                        <br />
                        Images Processed: {{importStatus.processed_images}}/{{importStatus.total_images}}
                  </div>
              </div>

              <SessionTabs :tabOptions="tabOptions" :selectedTab="selectedTab" @sessionTabInterface="changeTab" />
              <ProductTab v-show="selectedTab == 'Products'" :products="productList" @productInterface="updateProductDetailsContainer" />
              <IssueTab v-if="selectedTab == 'Issues'" :products="productList" @closeInterface="updateProductDetailsContainer" />
              <!-- <SessionOverview v-show="selectedTab == 'Overview'" :products="productList"/> -->
            </div>
          </div>
        </div>
        <div class="col-sm-3 col-md-3 middle pl-0">
          <SessionOverview :products="productList" :session="session" :type="'photodesk'"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MiniLoader from '@/components/common/MiniLoader'
import SessionTabs from '@/components/common/SessionView/SessionTabs'
import SessionInfoBlock from '@/components/common/SessionView/SessionInfoBlock'
import ProductTab from '@/components/photodesk/ViewSession/ProductTab'
import IssueTab from '@/components/photodesk/ViewSession/IssueTab'
import ProductDetails from '@/components/photodesk/ViewSession/ProductDetails'
import SessionOverview from '@/components/photodesk/ViewSession/SessionOverview'
import EmptyState from '@/components/common/EmptyState'

export default {
  name: 'session-view',
  props: ['id_session'],
  components: {
    SessionTabs,
    SessionInfoBlock,
    ProductTab,
    IssueTab,
    ProductDetails,
    EmptyState,
    SessionOverview
  },
  mounted: function () {
    this.getInitialSessionDetails()
    this.startSocket()
  },
  data: function () {
    return {
      tabOptions: ['Products', 'Issues'],
      selectedTab: 'Products',
      photographer: [],
      vm: '',
      stylist: '',
      makeupartist: '',
      shootcoordinator: '',
      session: '',
      products: [],
      selectedProduct: '',
      importStatus: {
        total_images: 0,
        processed_images: 0
      },
      loading: true
    }
  },
  computed: {
    productList () {
      return this.products
    },
    sessionInfoBlock () {
      return {
        mainUser: this.photographer,
        session: this.session
      }
    }
  },
  methods: {
    startSocket: function () {
      var self = this
      var channel = this.$pusher.subscribe('import')
      channel.bind('notification', function (data) {
        let message = JSON.parse(data)
        if (message.data.id_photodesk_session == self.id_session) {
          if (message.data.status == 1 || message.data.status == 0) {
            location.reload()
          }
          if (message.data.status == 4 || message.data.status == 5) {
            self.getSessionDetails()
            self.getProductList()
          }
        }
      })
    },
    getInitialSessionDetails: function () {
      var self = this

      self.$store.dispatch('updateLoading', 'true')

      self.getSessionDetails()

      self.$store.dispatch('updateLoading', 'false')
    },

    getSessionDetails: function () {
      var self = this

      const url = '/photodesk/session/show'
      let data = {
        id_photodesk_session: self.id_session
      }

      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.products = response.data.products
          self.photographer = response.data.photographer
          self.session = response.data.session
          if (self.session.type == 'bulk_import' || self.session.type == 'bulk') {
            self.getImportStatus()
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    getImportStatus: function () {
      var self = this

      const url = '/photodesk/import/status'
      let data = {
        id_photodesk_session: self.id_session
      }

      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.importStatus = response.data.import
        })
        .catch(function (error) {
          console.log(error)
        })
    },

    getProductList: function () {
      var self = this

      const url = '/photodesk/session/show'
      let data = {
        id_photodesk_session: self.id_session
      }

      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.products = response.data.products
        })
        .catch(function (error) {
          console.log(error)
        })
    },

    updateProductDetailsContainer: function (product) {
      this.selectedProduct = product
    },
    changeTab: function (tab) {
      this.selectedTab = tab
    },
    formatAvatar: function (user) {
      return 'background-image: url("http://52.66.102.131' + user.avatar + '")'
    }
  },
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },
  watch: {
    selectedProduct () {}
  }
}
</script>

<style>
.table th,
.table td {
  border: none;
}
.support-index {
  display: block !important;
}
</style>
